var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"th-exp-img-modal-ref",attrs:{"id":"th-exp-image-modal","hide-footer":"","title":"Experience Images"}},[_c('div',{staticClass:"mb-5 mt-5"},[_c('Slider',{attrs:{"images":_vm.images,"controls":true,"image-size":"large"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }